import type { UseQueryResult } from '@tanstack/react-query';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';
import type { GeneralFilter } from '~/shared/data-contract/filter';
import type { LearningOpportunitiesStatistics } from '~/shared/data-contract/learning-opportunities';
import { learningOpportunitiesStatisticsSchema } from '~/shared/data-contract/learning-opportunities';

import { learningOpportunityKeys, learningOpportunityPathnames } from './query-keys';

export const useLearningOpportunitiesStatisticsQuery = ({
    filter,
}: {
    readonly filter?: GeneralFilter;
} = {}): UseQueryResult<LearningOpportunitiesStatistics> => {
    const { validatingCobrainerApiFetcher } = useContext(ApplicationContext);

    return useQuery({
        placeholderData: keepPreviousData,
        queryFn: async () => {
            const result = await validatingCobrainerApiFetcher.postJson(learningOpportunitiesStatisticsSchema, {
                pathname: learningOpportunityPathnames.statistics,
                payload: { filter },
            });

            if (result.isOk) {
                return result.value;
            }

            throw result.error;
        },
        queryKey: learningOpportunityKeys.statistics(filter),
        throwOnError: false,
    });
};
